export const parseTextToID = (text) => text.toLowerCase().replaceAll(" ", "-");
